module.exports = __webpack_public_path__ + "img/wales-logo-icon.49ee62e6.png";